import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { getRecentPayments } from '../../redux/actions/payment';
import BottomNav from '../BottomNav';
import Loading from '../Loading';
import TopBar from '../TopBar'
import Paystack from './Paystack';
import swal from "sweetalert";
import { check_token } from '../../utils';
import { AiFillEye, AiOutlineDollarCircle, AiOutlineMail, AiOutlinePhone, AiOutlineFileText } from 'react-icons/ai';
import { FaWallet, FaCreditCard, FaHistory } from 'react-icons/fa';
import { MdAccountBalance, MdPayment } from 'react-icons/md';
import PaymentModal from './PaymentModal'; 
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';

export default function PaymentHome() {
    const dispatch = useDispatch();
    const { loading, success, data } = useSelector(state => state.getRecentPayments);
    const createStore = useSelector((state) => state.createPayment);
    let user = JSON.parse(localStorage.getItem('userInfo'));
    const navigate = useNavigate();
    const [state, setState] = useState({
        amount: '',
        email: user && user.email ? user.email : '',
        phone: user && user.mobile ? user.mobile : '',
        id: user && user.id ? user.id : '',
        notes: ''
    });
    const [recentPayments, setRecentPayments] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [finalAmount, setFinalAmount] = useState(0); 

    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'NGN',
    });

    useEffect(() => {
        check_token();
        dispatch(getRecentPayments(user && user.id ? user.id :state.id ))
        setRecentPayments(data?.data?.recent_transactions)
        if(createStore.success) {
            setShowModal(false);
        }
    }, [success, createStore.success]);

    const handleOpenModal = () => {
        if (!state.amount || state.amount == 0 || isNaN(state.amount)) {
            toast.warning('Please enter an amount');
            return
        }
        setShowModal(true);
    };


    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirmPayment = (totalAmount) => {
        setFinalAmount(totalAmount);
        setShowModal(false);
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <TopBar url={"/homedashboard"} title={'Payment'} />
            
            {/* Main Content Container */}
            <div className="px-4 pb-24 pt-4">
                {/* Balance Card */}
                <div className="bg-gradient-to-br from-primary100 via-emerald-600 to-teal-600 rounded-3xl p-6 mb-6 shadow-xl">
                    <div className="flex items-center justify-between text-white">
                        <div>
                            <div className="flex items-center mb-2">
                                <FaWallet className="mr-2 text-xl" />
                                <span className="text-white/80 text-sm font-medium">Current Balance</span>
                            </div>
                            <p className="text-3xl font-bold">
                                {user && user.acc_balance ? formatter.format(data?.data?.acc_balance) : '₦0.00'}
                            </p>
                        </div>
                        <div className="p-4 bg-white/20 rounded-2xl backdrop-blur-sm">
                            <MdAccountBalance className="text-3xl text-white" />
                        </div>
                    </div>
                </div>

                {/* Payment Form Card */}
                <div className="bg-white rounded-3xl shadow-xl p-6 mb-6">
                    <div className="flex items-center mb-6">
                        <div className="p-3 bg-primary100 rounded-2xl mr-4">
                            <MdPayment className="text-white text-2xl" />
                        </div>
                        <div>
                            <h2 className="text-xl font-bold text-gray-800">Make Payment</h2>
                            <p className="text-gray-500 text-sm">Add funds to your account</p>
                        </div>
                    </div>

                    <div className="space-y-6">
                        {/* Amount Input */}
                        <div>
                            <label className="flex items-center text-gray-700 font-semibold mb-3">
                                <AiOutlineDollarCircle className="mr-2 text-primary100" />
                                Amount
                            </label>
                            <div className="relative">
                                <input 
                                    type="number"
                                    className="w-full px-4 py-4 pl-12 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-primary100 focus:ring-4 focus:ring-primary100/20 transition-all duration-300 text-lg font-semibold"
                                    placeholder="Enter amount (e.g., 5000)"
                                    value={state.amount}
                                    onChange={(e) => setState({ ...state, amount: e.target.value })}
                                />
                                <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 font-bold">₦</span>
                            </div>
                        </div>

                        {/* Email Input */}
                        <div>
                            <label className="flex items-center text-gray-700 font-semibold mb-3">
                                <AiOutlineMail className="mr-2 text-primary100" />
                                Email <span className="text-gray-400 text-sm ml-1">(for receipt)</span>
                            </label>
                            <input 
                                type="email"
                                className="w-full px-4 py-4 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-primary100 focus:ring-4 focus:ring-primary100/20 transition-all duration-300"
                                placeholder="example@gmail.com"
                                value={state.email.trim()}
                                onChange={(e) => setState({ ...state, email: e.target.value })}
                            />
                        </div>

                        {/* Phone Input */}
                        <div>
                            <label className="flex items-center text-gray-700 font-semibold mb-3">
                                <AiOutlinePhone className="mr-2 text-primary100" />
                                Phone Number
                            </label>
                            <input 
                                type="tel"
                                className="w-full px-4 py-4 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-primary100 focus:ring-4 focus:ring-primary100/20 transition-all duration-300"
                                placeholder="Enter phone number"
                                value={state.phone}
                                onChange={(e) => setState({ ...state, phone: e.target.value })}
                            />
                        </div>

                        {/* Notes Input */}
                        <div>
                            <label htmlFor="message" className="flex items-center text-gray-700 font-semibold mb-3">
                                <AiOutlineFileText className="mr-2 text-primary100" />
                                Notes <span className="text-gray-400 text-sm ml-1">(optional)</span>
                            </label>
                            <textarea 
                                id="message" 
                                rows="3" 
                                className="w-full px-4 py-4 border-2 border-gray-200 rounded-2xl focus:outline-none focus:border-primary100 focus:ring-4 focus:ring-primary100/20 transition-all duration-300 resize-none" 
                                placeholder="Add any notes for this payment..."
                                value={state.notes}
                                onChange={(e) => setState({ ...state, notes: e.target.value })}
                            />
                        </div>

                        {/* Confirm Payment Button */}
                        <button 
                            className="w-full bg-gradient-to-r from-primary100 to-emerald-600 text-white py-4 rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transform hover:scale-[1.02] transition-all duration-300 flex items-center justify-center space-x-2"
                            onClick={handleOpenModal}
                        >
                            <FaCreditCard className="text-xl" />
                            <span>Confirm Payment</span>
                        </button>
                    </div>
                </div>

                {/* Divider */}
                <div className="flex items-center my-8">
                    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                    <div className="px-4">
                        <FaHistory className="text-gray-400 text-xl" />
                    </div>
                    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                </div>

                {/* Transaction History */}
                <div className="bg-white rounded-3xl shadow-xl overflow-hidden">
                    <div className="p-6 border-b border-gray-100">
                        <h3 className="text-xl font-bold text-gray-800 flex items-center">
                            <FaHistory className="mr-3 text-primary100" />
                            Transaction History
                        </h3>
                        <p className="text-gray-500 text-sm mt-1">Your recent payment activities</p>
                    </div>

                    {/* Desktop Table View */}
                    <div className="hidden md:block">
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                            Date
                                        </th>
                                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                            Amount
                                        </th>
                                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                            Type
                                        </th>
                                        <th className="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider">
                                            Action
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {loading ? (
                                        <tr>
                                            <td colSpan="4" className="py-12">
                                                <div className="flex justify-center items-center">
                                                    <Loading fullScreen={true} />
                                                </div>
                                            </td>
                                        </tr>
                                    ) : recentPayments?.length > 0 ? (
                                        recentPayments.map((payment, index) => (
                                            <tr key={index} className="hover:bg-gray-50 transition-colors">
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-medium text-gray-900">
                                                        {new Date(payment.created).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })}
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-semibold text-gray-900">
                                                        {formatter.format(payment.amount)}
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className="px-3 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                                                        {payment.activity_type}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <Link to={"/payment_receipt/" + payment.session_id}>
                                                        <button className="p-2 text-primary100 hover:bg-primary100 hover:text-white rounded-xl transition-all duration-300">
                                                            <AiFillEye size={20} />
                                                        </button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="py-12">
                                                <div className="flex flex-col items-center justify-center text-center">
                                                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                                        <FaHistory className="text-gray-400 text-2xl" />
                                                    </div>
                                                    <p className="text-gray-500 font-medium">No transaction records</p>
                                                    <p className="text-gray-400 text-sm mt-1">Your payment history will appear here</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Mobile Card View */}
                    <div className="md:hidden">
                        {loading ? (
                            <div className="flex justify-center items-center py-12">
                                <Loading />
                            </div>
                        ) : recentPayments?.length > 0 ? (
                            <div className="divide-y divide-gray-200">
                                {recentPayments.map((payment, index) => (
                                    <div key={index} className="p-4 hover:bg-gray-50 transition-colors">
                                        <div className="flex items-center justify-between mb-2">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                                                    <MdPayment className="text-green-600 text-lg" />
                                                </div>
                                                <div>
                                                    <p className="font-semibold text-gray-900">
                                                        {formatter.format(payment.amount)}
                                                    </p>
                                                    <p className="text-sm text-gray-500">
                                                        {new Date(payment.created).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'short',
                                                            day: 'numeric'
                                                        })}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-3">
                                                <span className="px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                                                    {payment.activity_type}
                                                </span>
                                                <Link to={"/payment_receipt/" + payment.session_id}>
                                                    <button className="p-2 text-primary100 hover:bg-primary100 hover:text-white rounded-xl transition-all duration-300">
                                                        <AiFillEye size={18} />
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="flex flex-col items-center justify-center text-center py-12">
                                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                    <FaHistory className="text-gray-400 text-2xl" />
                                </div>
                                <p className="text-gray-500 font-medium">No transaction records</p>
                                <p className="text-gray-400 text-sm mt-1">Your payment history will appear here</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Payment Modal */}
            <PaymentModal 
                showModal={showModal} 
                handleClose={handleCloseModal} 
                amount={state.amount} 
                onConfirm={handleConfirmPayment} 
                state={state} 
            />

            <BottomNav color3={'text-primary100'} />
        </div>
    );
}
